console.log('process.env.REACT_APP_DEV_BE_URL', process.env.REACT_APP_DEV_BE_URL);

const dev = {
  API_ENDPOINT_URL: process.env.REACT_APP_DEV_BE_URL ?? 'http://localhost:8080',
};

const prod = {
  API_ENDPOINT_URL: 'https://api.sotravel.me',
};

const test = {
  API_ENDPOINT_URL: 'https://api.sotravel.me',
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev;
    case 'production':
      return prod;
    case 'test':
      return test;
    default:
      break;
  }
};

export const env = getEnv();
